import { ConfigurationFunction, ConfigurationFunctionNameMap, ConfigurationFunctionNodeMap, ConfigurationNode, SelectOption } from "@core/types";

export const CONFIGURATION_FUNCTION_NAME_MAP: ConfigurationFunctionNameMap = {
    [ConfigurationFunction.INTERNET_LTE]: "4G LTE",
    [ConfigurationFunction.INTERNET_5G_NR]: "5G NR",
    [ConfigurationFunction.INTERNET_EWAN]: "EWAN",
    [ConfigurationFunction.INTERNET_EWAN_MULTIPLE_SERVICE]: "EWAN (Multiple Services)",
    [ConfigurationFunction.INTERNET_WIRELESS_CLIENT]: "WirelessClient",
    [ConfigurationFunction.WIFI_24G]: "Wireless 2.4G",
    [ConfigurationFunction.WIFI_5G]: "Wireless 5G",
    [ConfigurationFunction.SPEED_TEST_SERVER]: "Speed Test Server",
    [ConfigurationFunction.CBSD]: "CBSD",
    [ConfigurationFunction.SERIAL_1]: "Serial Port 1",
    [ConfigurationFunction.SERIAL_2]: "Serial Port 2",
    [ConfigurationFunction.RGOOSE]: "RGOOSE",
    [ConfigurationFunction.PTP]: "PTP",
    [ConfigurationFunction.DEVICE_MANAGMENT]: "Device Management",
    [ConfigurationFunction.ACCESS_CONTROL]: "Access Control",
    [ConfigurationFunction.BECENTRAL]: "BECentral",
    [ConfigurationFunction.USER_MANAGEMENT]: "User Management"
};

export const CONFIGURATION_FUNCTION_NODE_MAP: ConfigurationFunctionNodeMap = {
    [ConfigurationFunction.INTERNET_LTE]: ConfigurationNode.INTERNET_LTE,
    [ConfigurationFunction.INTERNET_5G_NR]: ConfigurationNode.INTERNET_5G_NR,
    [ConfigurationFunction.INTERNET_EWAN]: ConfigurationNode.INTERNET_EWAN,
    [ConfigurationFunction.INTERNET_EWAN_MULTIPLE_SERVICE]: ConfigurationNode.INTERNET_EWAN_MULTIPLE_SERVICE,
    [ConfigurationFunction.INTERNET_WIRELESS_CLIENT]: ConfigurationNode.INTERNET_WIRELESS_CLIENT,
    [ConfigurationFunction.WIFI_24G]: ConfigurationNode.WIFI_24G,
    [ConfigurationFunction.WIFI_5G]: ConfigurationNode.WIFI_5G,
    [ConfigurationFunction.SPEED_TEST_SERVER]: ConfigurationNode.SPEED_TEST_SERVER,
    [ConfigurationFunction.CBSD]: ConfigurationNode.CBSD,
    [ConfigurationFunction.SERIAL_1]: ConfigurationNode.SERIAL_1,
    [ConfigurationFunction.SERIAL_2]: ConfigurationNode.SERIAL_2,
    [ConfigurationFunction.BECENTRAL]: ConfigurationNode.BECENTRAL,
    [ConfigurationFunction.RGOOSE]: ConfigurationNode.RGOOSE,
    [ConfigurationFunction.PTP]: ConfigurationNode.PTP,
    [ConfigurationFunction.DEVICE_MANAGMENT]: ConfigurationNode.DEVICE_MANAGMENT,
    [ConfigurationFunction.ACCESS_CONTROL]: ConfigurationNode.ACCESS_CONTROL,
    [ConfigurationFunction.USER_MANAGEMENT]: ConfigurationNode.USER_MANAGEMENT
};

export const CONFIGURATION_FUNCTION_OPTION: { [key: string]: Array<SelectOption> } = {
    "Interface": [
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.INTERNET_LTE], value: ConfigurationFunction.INTERNET_LTE },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.INTERNET_5G_NR], value: ConfigurationFunction.INTERNET_5G_NR },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.INTERNET_EWAN], value: ConfigurationFunction.INTERNET_EWAN },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.INTERNET_EWAN_MULTIPLE_SERVICE], value: ConfigurationFunction.INTERNET_EWAN_MULTIPLE_SERVICE },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.INTERNET_WIRELESS_CLIENT], value: ConfigurationFunction.INTERNET_WIRELESS_CLIENT }
    ],
    // "Dual WAN": [],
    "Wi-Fi": [
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.WIFI_24G], value: ConfigurationFunction.WIFI_24G },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.WIFI_5G], value: ConfigurationFunction.WIFI_5G }
    ],
    "Advanced Setup": [
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.SERIAL_1], value: ConfigurationFunction.SERIAL_1 },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.SERIAL_2], value: ConfigurationFunction.SERIAL_2 },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.RGOOSE], value: ConfigurationFunction.RGOOSE },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.PTP], value: ConfigurationFunction.PTP },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.CBSD], value: ConfigurationFunction.CBSD },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.SPEED_TEST_SERVER], value: ConfigurationFunction.SPEED_TEST_SERVER },
    ],
    "Access Management": [
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.DEVICE_MANAGMENT], value: ConfigurationFunction.DEVICE_MANAGMENT },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.ACCESS_CONTROL], value: ConfigurationFunction.ACCESS_CONTROL },
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.BECENTRAL], value: ConfigurationFunction.BECENTRAL },
    ],
    // "VPN": [],
    "Maintenance": [
        { name: CONFIGURATION_FUNCTION_NAME_MAP[ConfigurationFunction.USER_MANAGEMENT], value: ConfigurationFunction.USER_MANAGEMENT }
    ],
    // "LTE TTL and HL": [],
};